import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import "../housestyle.css";
import "./Blogs.css";
import api from "../API/Api";
import DiscordMarkdown from "../components/DiscordMarkdown";

const TAG_MAP = { new: "tag-new", fix: "tag-fix", change: "tag-change", event: "tag-event" };

function formatDate(iso) {
  return new Date(iso).toLocaleDateString("en-GB", { day: "2-digit", month: "long", year: "numeric" });
}

function parseTags(raw) {
  if (Array.isArray(raw)) return raw;
  if (!raw) return [];
  return raw.split(',').map(t => t.trim()).filter(Boolean);
}

export default function BlogPost() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);
  const [views, setViews] = useState(null);

  useEffect(() => {
    api('getsneakpeak', { id: Number(id) }).then(res => {
      setPost(res.isSuccess ? res.data : null);
      setLoading(false);
    });
  }, [id]);

  useEffect(() => {
    if (!post) return;
    const key = `viewed_${post.id}`;
    if (sessionStorage.getItem(key)) {
      api('getviews', { blog_id: post.id }).then(res => {
        if (res.isSuccess) setViews(res.data?.views ?? 0);
      });
    } else {
      sessionStorage.setItem(key, '1');
      api('trackview', { blog_id: post.id }).then(res => {
        if (res.isSuccess) setViews(res.data?.views ?? 0);
      });
    }
  }, [post?.id]);

  if (loading) return <div style={{ padding: '6rem 2rem', textAlign: 'center', color: 'var(--text-muted)' }}>Loading…</div>;

  if (!post) return (
    <div style={{ padding: "4rem 2rem", textAlign: "center" }}>
      <img src="/mc-icons/barrier.png" alt="barrier" style={{ width: 56, height: 56, imageRendering: "pixelated", marginBottom: "1rem" }} />
      <h2 style={{ fontSize: "var(--t-2xl)", marginBottom: "0.5rem" }}>Blog not found</h2>
      <p style={{ color: "var(--text-muted)", marginBottom: "1.5rem" }}>This post doesn't exist or was removed.</p>
      <button className="btn btn-secondary" onClick={() => navigate("/blogs")}>← Back to Blogs</button>
    </div>
  );

  const tags = parseTags(post.tags);

  return (
    <>
      <div className="bp-hero">
        {post.thumbnail_url
          ? <img src={post.thumbnail_url} alt={post.title} className="bp-hero-img" />
          : <div className="bp-hero-blank" />
        }
        <div className="bp-hero-overlay" />
        <div className="bp-hero-content container">
          <button className="btn btn-secondary bp-back" onClick={() => navigate("/blogs")}>← Blogs</button>
          {views !== null && <span className="bp-views">👁 {views} views</span>}
          <div className="blog-card-tags bp-hero-tags">
            <div style={{ display: "flex", gap: "8px", marginBottom: "0.5rem", alignItems: "center" }}>
              <span className="blog-card-category">{post.category}</span>
              {post.subcategory && post.subcategory !== 'General' && (
                <span className="blog-card-category" style={{ background: "rgba(192,57,43,0.75)", color: "#fff" }}>
                  {post.subcategory}
                </span>
              )}
            </div>
            {tags.map(t => <span key={t} className={`tag ${TAG_MAP[t] ?? ""}`}>{t}</span>)}
          </div>
          <h1 className="bp-title">{post.title}</h1>
          {post.date && <p className="bp-date">{formatDate(post.date)}</p>}
        </div>
      </div>

      <div className="container bp-content">
        {post.summary && <div className="bp-summary">{post.summary}</div>}
        <div className="divider" />
        <div className="bp-body">
          <DiscordMarkdown text={post.content || ''} />
        </div>
        <div className="divider" style={{ marginTop: "2.5rem" }} />
        <button className="btn btn-secondary" onClick={() => navigate("/blogs")}>← Back to all blogs</button>
      </div>
    </>
  );
}
